import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {HttpRequestOptions} from '@dcp/configurator';
import {Observable, throwError} from 'rxjs';
import {concatMap} from 'rxjs/operators';
import {DcpKymaService} from './dcp-kyma.service';
import {ProductDetails} from '@app/model/dcp-product-details';

@Injectable({
  providedIn: 'root',
})
export class DcpProductDetailsService {
  constructor(private http: HttpClient, private kymaService: DcpKymaService) {}

  getProduct(technicalName: string, country: string = 'US'): Observable<ProductDetails> {
    return this.kymaService
      .prepareAuthConfig()
      .pipe(
        concatMap((config: HttpRequestOptions) =>
          this.http.get<ProductDetails>(
            `${this.kymaService.getUrl('productDetails')}/${technicalName}/country/${country}/language/en`,
            config
          )
        )
      );
  }

  handleError(error: HttpErrorResponse) {
    return throwError(() => error);
  }
}
